import React, { PureComponent, useRef, useState, useEffect, useContext, useMemo } from 'react'
import { Input as InputStrap, InputGroup, InputGroupAddon, Button as ButtonStrap } from 'reactstrap'
import PageEditor from './PageEditor'
import { EditorState, RichUtils, convertFromRaw, convertToRaw, ContentState } from 'draft-js'
import Editor, { createEditorStateWithText } from 'draft-js-plugins-editor'
import createInlineToolbarPlugin, { Separator } from 'draft-js-inline-toolbar-plugin'
import 'draft-js-inline-toolbar-plugin/lib/plugin.css'
import editorStyles from '../css/editor_styles.css'
import ImageUpload from './ImageUpload'
import Button from './Button'
import {
    ItalicButton,
    BoldButton,
    UnderlineButton,
    // CodeButton,
    HeadlineOneButton,
    HeadlineTwoButton,
    HeadlineThreeButton,
    UnorderedListButton,
    OrderedListButton,
    BlockquoteButton,
    // CodeBlockButton,
} from 'draft-js-buttons'
import createLinkPlugin from 'draft-js-anchor-plugin'
import { stateToHTML } from 'draft-js-export-html'
import htmlToDraft from 'html-to-draftjs'
import Select from 'react-select'
import { ArticleEditContext, TranslationContext } from './ArticleEdit'
import { isLinkLegit } from './PageEditor'
import useTranslation from '../hooks/useTranslation'
import useId from '../hooks/useId'
import { LOCALE, DEEPL_LOCALE } from '../constants/'
import Flag from './Flag'
import { InlineLoading } from './Loading'

// class Input extends React.PureComponent {
const Input = React.memo(function Input(props) {
    const { translateText } = useContext(ArticleEditContext)
    const { type, isLoading } = props || {}
    const onChange = (e) => {
        console.log(e, props.onChange, (typeof e.value !== 'undefined' && e.value) || e.target.value)
        props.onChange && props.onChange((typeof e === 'object' && e.label ? e : typeof e.value !== 'undefined' && e.value) || e.target.value)
    }
    const options_array_source = (typeof props.options === 'function' && props.options()) || props.options || []
    const options_array = useMemo(() => {
        if (props.options) {
            return ((typeof props.options === 'function' && props.options()) || props.options).map((o) => {
                return typeof o?.value !== 'undefined' ? o : { ...o, value: o.id }
            })
        } else {
            return []
        }
    }, [options_array_source.map((t) => t.value + '-' + t.id)])
    // const options_array = []
    const opts = useMemo(
        () => (isLoading && [{ label: 'Loading', value: '' }]) || options_array.map((o) => ({ ...o, value: o.value + '', label: o.label || o.title })) || [],
        [options_array]
    )

    if (type === 'advanced-textarea') {
        return <DraftJS {...props} />
    } else if (type === 'i18n-advanced-textarea') {
        return <DraftJSi18n {...props} />
    } else if (type === 'native-select') {
        let { value, options, isLoading, ...props } = props
        const options_array = (typeof props.options === 'function' && props.options()) || props.options
        return (
            <select {...props} className={'form-control' + ((props.className && ' ' + props.className) || '')} value={value} onChange={onChange}>
                {(isLoading && <option key="loading">Loading...</option>) ||
                    (options_array || []).map((option) => (
                        <option value={option.value} key={`option-${option.value}`}>
                            {option.label}
                        </option>
                    ))}
            </select>
        )
    } else if (type === 'select') {
        let { value, options, isLoading, ..._props } = props
        return (
            <Select
                {..._props}
                className={(props.className && ' ' + props.className) || ''}
                value={opts.find((o) => o.value == value || o.id === value)}
                onChange={onChange}
                options={opts}
            />
        )
        // <select {...props} className={'form-control'+(props.className&&(' '+props.className)||'')} value={value} onChange={onChange}>
        //     {isLoading && <option key="loading">Loading...</option> ||
        //     (options_array||[]).map(option => <option value={option.value} key={`option-${option.value}`}>{option.label}</option>)
        // }</Select>
    } else if (type === 'page-editor') {
        return (
            <React.Fragment>
                <PageEditor {...props} />
            </React.Fragment>
        )
    } else if (type === 'image') {
        let { value, ..._props } = props
        return (
            <ImageUpload
                image={props.image || props.content}
                image_key={props.image_key || undefined}
                parent_model={props.parent_model}
                parent_id={props.parent_id}
                parent={props.parent}
                site_id={props.site_id}
                content={props.content}
                onChange={() => {}}
            />
        )
    } else {
        let { value, article, append, ..._props } = props
        let translate_addon
        if (article?.locale && article?.translated_from__locale) {
            translate_addon = true
        }
        value = value || ''
        return (
            (translate_addon && (
                <>
                    <InputGroup>
                        <InputStrap {..._props} value={value} />
                        <InputGroupAddon addonType="append">
                            <ButtonStrap
                                color="light"
                                className="input-group-text"
                                onClick={() => {
                                    translateText({
                                        text: value,
                                        source_locale: article?.translated_from__locale,
                                        target_locale: article?.locale,
                                    }).then(({ text }) => props.onChange && props.onChange({ target: { name: props.name, value: text } }))
                                }}
                            >
                                <Flag locale={article.locale} />
                            </ButtonStrap>
                        </InputGroupAddon>
                        {append}
                    </InputGroup>
                </>
            )) ||
            (props.append && (
                <>
                    <InputGroup>
                        <InputStrap {..._props} value={value} />
                        {props.append}
                    </InputGroup>
                </>
            )) || (
                <>
                    <InputStrap {..._props} value={value} />
                </>
            )
        )
    }
})

class HeadlinesPicker extends PureComponent {
    componentDidMount() {
        setTimeout(() => {
            window.addEventListener('click', this.onWindowClick)
        })
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onWindowClick)
    }

    onWindowClick = () =>
        // Call `onOverrideContent` again with `undefined`
        // so the toolbar can show its regular content again.
        this.props.onOverrideContent(undefined)

    render() {
        const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton]
        return (
            <div>
                {buttons.map((
                    Button,
                    i // eslint-disable-next-line
                ) => (
                    <Button key={i} {...this.props} />
                ))}
            </div>
        )
    }
}

class HeadlinesButton extends PureComponent {
    // When using a click event inside overridden content, mouse down
    // events needs to be prevented so the focus stays in the editor
    // and the toolbar remains visible  onMouseDown = (event) => event.preventDefault()
    onMouseDown = (event) => event.preventDefault()

    onClick = () =>
        // A button can call `onOverrideContent` to replace the content
        // of the toolbar. This can be useful for displaying sub
        // menus or requesting additional information from the user.
        this.props.onOverrideContent(HeadlinesPicker)

    render() {
        return (
            <div onMouseDown={this.onMouseDown} className={'headlineButtonWrapper'}>
                <button onClick={this.onClick} className={'headlineButton'}>
                    H
                </button>
            </div>
        )
    }
}

// pid: this.props.content.external_id,
// bid: this.props.id,
// sid: context.site.id,
// aid: this.props.aid,
// iid: this.props.content.image.id
let optionsFn = (site) => ({
    entityStyleFn: (entity) => {
        const entityType = entity.get('type').toLowerCase()
        if (entityType === 'link') {
            const data = entity.getData()
            // console.log(entity, data)
            const is_external = !data?.url?.includes('://' + site?.url)
            const attributes = { href: data.url, target: is_external ? '_blank' : undefined, rel: 'noopener', ['data-bid']: data.id }
            return {
                element: 'a',
                attributes,
                // style: {
                //     // Put styles here...
                // },
            }
        }
    },
})

const DraftJSi18n = React.memo(function DraftJSi18n(props) {
    const { value } = props

    const { refreshTranslationUsage, article } = useContext(ArticleEditContext)

    const [isError, setIsError] = useState(false)

    const [{ linkPlugin, inlineToolbarPlugin, InlineToolbar, linkPluginOriginal, inlineToolbarPluginOriginal, InlineToolbarOriginal }] = useState(() => {
        const linkPlugin = createLinkPlugin()
        const inlineToolbarPlugin = createInlineToolbarPlugin()
        const InlineToolbar = inlineToolbarPlugin.InlineToolbar
        const linkPluginOriginal = createLinkPlugin()
        const inlineToolbarPluginOriginal = createInlineToolbarPlugin()
        const InlineToolbarOriginal = inlineToolbarPluginOriginal.InlineToolbar
        return { linkPlugin, inlineToolbarPlugin, InlineToolbar, linkPluginOriginal, inlineToolbarPluginOriginal, InlineToolbarOriginal }
    })

    const [isLoading, setIsLoading] = useState(false)

    const myRef = useRef()
    const myRefOriginal = useRef()
    const [editorStateOriginal, setEditorStateOriginal] = useState(() => {
        const val = value?.original?.blocks ? value.original : (value?.blocks && value) || null
        return (val && EditorState.createWithContent(convertFromRaw(val))) || EditorState.createEmpty() /* || EditorState.createEmpty()*/
    })
    const [editorState, setEditorState] = useState(
        () =>
            (typeof value === 'object' && value.source && EditorState.createWithContent(convertFromRaw(value.source))) ||
            EditorState.createWithContent(ContentState.createFromText((typeof value === 'string' && value) || ''))
    )

    const onChangeOriginal = (_editorState, pluginsMethods) => {
        const stateContentStateOriginal = editorStateOriginal.getCurrentContent()
        const currentContent = _editorState.getCurrentContent()
        if (stateContentStateOriginal !== currentContent) {
            /* console.log('onChangeOriginal triggered') */

            props.onChange &&
                props.onChange(
                    {
                        target: {
                            value: {
                                original: convertToRaw(currentContent),
                            },
                        },
                    },
                    true
                )
        }
        setEditorStateOriginal(_editorState)
    }
    const onChange = (_editorState, pluginsMethods) => {
        const stateContentState = editorState.getCurrentContent()
        const currentContent = _editorState.getCurrentContent()
        if (stateContentState !== currentContent) {
            /* console.log('onChange triggered') */

            const rawCurrentContent = convertToRaw(currentContent)
            props.onChange &&
                props.onChange(
                    {
                        target: {
                            value: {
                                source: rawCurrentContent,
                                html: stateToHTML(currentContent, optionsFn(article?.site)),
                            },
                        },
                    },
                    true
                )
            if (props.validityFn) {
                const valid = props.validityFn(rawCurrentContent)
                console.log({ valid })
                if (valid) {
                    isError && setIsError(false)
                } else {
                    !isError && setIsError(true)
                }
            }
        }
        setEditorState(_editorState)
    }

    useEffect(() => {
        const valid = props.validityFn ? props.validityFn(convertToRaw(editorState.getCurrentContent())) : true
        !valid && !isError && setIsError(true)
    }, [])

    const [localCleanUp, setLocalCleanUp] = useState(0)
    const [localConvertLinks, setLocalConvertLinks] = useState(0)

    useEffect(() => {
        if (void 0 !== props.cleanUp && props.cleanUp !== localCleanUp) {
            console.log('cleanUp', props)
            const content = convertToRaw(editorState.getCurrentContent())
            console.log({ content })
            const keeping = Object.keys(content?.entityMap).reduce((acc, entity_key) => {
                if (isLinkLegit(article.site)(content?.entityMap[entity_key]?.data?.url)) {
                    acc[entity_key] = content?.entityMap[entity_key]
                }
                return acc
            }, {})
            console.log('keeping', { ...content, entityMap: keeping })
            const updated_value = { ...content, entityMap: keeping }
            setEditorState(EditorState.createWithContent(convertFromRaw(updated_value)))
            props.onChange &&
                props.onChange({
                    target: {
                        value: updated_value,
                    },
                })
            setLocalCleanUp(props.cleanUp)
        }
    }, [props.cleanUp])

    const handleKeyCommandOriginal = (command) => {
        const newState = RichUtils.handleKeyCommand(editorStateOriginal, command)
        if (newState) {
            onChangeOriginal(newState)
            return 'handled'
        }
        return 'not-handled'
    }
    const handleKeyCommand = (command) => {
        const newState = RichUtils.handleKeyCommand(editorState, command)
        if (newState) {
            onChange(newState)
            return 'handled'
        }
        return 'not-handled'
    }

    const { translate } = useTranslation()

    const translateText = () => {
        const currentContent = editorStateOriginal.getCurrentContent()
        console.log(
            stateToHTML(currentContent, optionsFn(article?.site))
                .replace(/<br>/g, '<br />')
                .replace(/undefined/g, '')
        )
        setIsLoading(true)

        translate({
            text: stateToHTML(currentContent, optionsFn(article?.site))
                .replace(/<br>/g, '')
                .replace(/\n/g, '')
                .replace(/undefined/g, ''),
            source_lang: DEEPL_LOCALE[article.translated_from__locale] || undefined,
            target_lang: DEEPL_LOCALE[article.locale],
            tag_handling: 'xml',
        })
            .then((result) => {
                console.log(result.data)
                const blocksFromHtml = htmlToDraft(result.data.translations[0]?.text)
                const { contentBlocks, entityMap } = blocksFromHtml
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
                const editorState = EditorState.createWithContent(contentState)
                setEditorState(editorState)
                setIsLoading(false)
                refreshTranslationUsage && refreshTranslationUsage()
            })
            .catch(console.error)
    }
    const noTranslation = (!value.original || !value.source || (value.source && value.source === '')) && value.html !== '<p><br></p>'
    // noTranslation && console.log('noTranslation', value)

    useEffect(() => {
        if (void 0 !== props.convertLinks && props.convertLinks !== localConvertLinks) {
            const content = convertToRaw(editorState.getCurrentContent())
            console.log({ content })
            const converted = Object.keys(content?.entityMap).reduce((acc, entity_key) => {
                const link = content?.entityMap[entity_key]?.data?.url

                const candidate = article?.translated_from__site?.permalink_array.find((p) => link.includes('/' + p.permalink))
                // console.log('trying to convert', link, 'using', article?.translated_from__site?.permalink_array, candidate)
                const target = candidate && article.site.permalink_array.find((p) => p.translated_from__article_id === candidate.id)
                // console.log({ target })
                if (target) {
                    acc[entity_key] = {
                        ...content?.entityMap[entity_key],
                        data: { ...content?.entityMap[entity_key].data, url: 'https://' + article.site?.url + '/' + target.permalink },
                    }
                } else {
                    acc[entity_key] = content?.entityMap[entity_key]
                }
                return acc
            }, {})
            console.log({ converted })
            const updated_value = { ...content, entityMap: converted }
            setEditorState(EditorState.createWithContent(convertFromRaw(updated_value)))
            props.onChange &&
                props.onChange({
                    target: {
                        value: updated_value,
                    },
                })
            setLocalConvertLinks(props.convertLinks)
        }
    }, [props.convertLinks])

    return (
        <React.Fragment>
            <div
                className={'i18n-text-origin-container translation-ui-element ' + (editorStyles.editor || undefined)}
                onClick={() => {
                    myRefOriginal.current.focus()
                }}
            >
                <Editor
                    editorState={editorStateOriginal}
                    onChange={onChangeOriginal}
                    handleKeyCommand={handleKeyCommandOriginal}
                    plugins={[inlineToolbarPluginOriginal, linkPluginOriginal]}
                    ref={myRefOriginal}
                />
                {/* <InlineToolbarOriginal>
                    {(externalProps) => (
                        <React.Fragment>
                            <BoldButton {...externalProps} />
                            <ItalicButton {...externalProps} />
                            <UnderlineButton {...externalProps} />
                            <Separator {...externalProps} />
                            <linkPlugin.LinkButton {...externalProps} />
                            <Separator {...externalProps} />
                            <HeadlinesButton {...externalProps} />
                            <UnorderedListButton {...externalProps} />
                            <OrderedListButton {...externalProps} />
                            <BlockquoteButton {...externalProps} />
                        </React.Fragment>
                    )}
                </InlineToolbarOriginal> */}
            </div>
            <div className="translation-ui-element">
                <Button className={(noTranslation && 'btn-warning missing-translation') || 'btn-secondary'} onClick={translateText} disabled={isLoading}>
                    {(isLoading && (
                        <>
                            <InlineLoading />
                        </>
                    )) || (
                        <span>
                            <i className="fad fa-language" />
                        </span>
                    )}{' '}
                    Translate in {LOCALE[article.locale]} <Flag locale={article.locale} />
                </Button>
            </div>
            <div
                className={editorStyles.editor + (isError ? ' text-error' : '')}
                onClick={() => {
                    myRef.current.focus()
                }}
            >
                <Editor
                    editorState={editorState}
                    onChange={onChange}
                    handleKeyCommand={handleKeyCommand}
                    plugins={[inlineToolbarPlugin, linkPlugin]}
                    ref={myRef}
                />
                <InlineToolbar>
                    {(externalProps) => (
                        <React.Fragment>
                            <BoldButton {...externalProps} />
                            <ItalicButton {...externalProps} />
                            <UnderlineButton {...externalProps} />
                            <Separator {...externalProps} />
                            <linkPlugin.LinkButton {...externalProps} />
                            <Separator {...externalProps} />
                            <HeadlinesButton {...externalProps} />
                            <UnorderedListButton {...externalProps} />
                            <OrderedListButton {...externalProps} />
                            {/* <BlockquoteButton {...externalProps} /> */}
                        </React.Fragment>
                    )}
                </InlineToolbar>
            </div>
        </React.Fragment>
    )
})

const DraftJS = React.memo((props) => {
    const { value } = props
    const { article } = useContext(ArticleEditContext)

    const [{ linkPlugin, inlineToolbarPlugin, InlineToolbar }] = useState(() => {
        const linkPlugin = createLinkPlugin()
        const inlineToolbarPlugin = createInlineToolbarPlugin()
        const InlineToolbar = inlineToolbarPlugin.InlineToolbar
        return { linkPlugin, inlineToolbarPlugin, InlineToolbar }
    })

    const [isError, setIsError] = useState(false)

    const myRef = useRef()

    const [editorState, setEditorState] = useState(
        () =>
            (typeof value === 'object' && EditorState.createWithContent(convertFromRaw((value.source && value.source) || value))) ||
            EditorState.createWithContent(ContentState.createFromText(value || ''))
    )

    const onChange = (_editorState, pluginsMethods) => {
        const stateContentState = editorState.getCurrentContent()

        const currentContent = _editorState.getCurrentContent()
        const rawCurrentContent = convertToRaw(currentContent)
        if (stateContentState !== currentContent) {
            props.onChange && props.onChange({ target: { value: { source: rawCurrentContent, html: stateToHTML(currentContent, optionsFn(article?.site)) } } })
            if (props.validityFn) {
                const valid = props.validityFn(rawCurrentContent)
                if (valid) {
                    isError && setIsError(false)
                } else {
                    !isError && setIsError(true)
                }
            }
        }
        setEditorState(_editorState)
    }

    useEffect(() => {
        const valid = props.validityFn ? props.validityFn(convertToRaw(editorState.getCurrentContent())) : true
        !valid && !isError && setIsError(true)
    }, [])

    const handleKeyCommand = (command) => {
        const newState = RichUtils.handleKeyCommand(editorState, command)
        if (newState) {
            onChange(newState)
            return 'handled'
        }
        return 'not-handled'
    }

    useEffect(() => {
        // call onChange with this new information
        const stateContentState = editorState.getCurrentContent()
        props.onChange &&
            props.onChange({ target: { value: { source: convertToRaw(stateContentState), html: stateToHTML(stateContentState, optionsFn(article?.site)) } } })
    }, [value?.source?.entityMap?.length])

    return (
        <React.Fragment>
            <div
                className={editorStyles.editor + (isError ? ' text-error' : '')}
                onClick={() => {
                    myRef.current.focus()
                }}
            >
                <Editor
                    editorState={editorState}
                    onChange={onChange}
                    handleKeyCommand={handleKeyCommand}
                    plugins={[inlineToolbarPlugin, linkPlugin]}
                    ref={myRef}
                />
                <InlineToolbar>
                    {(externalProps) =>
                        (externalProps && (
                            <React.Fragment>
                                <BoldButton {...externalProps} />
                                <ItalicButton {...externalProps} />
                                <UnderlineButton {...externalProps} />
                                <Separator {...externalProps} />
                                <linkPlugin.LinkButton {...externalProps} />
                                <Separator {...externalProps} />
                                <HeadlinesButton {...externalProps} />
                                <UnorderedListButton {...externalProps} />
                                <OrderedListButton {...externalProps} />
                                <BlockquoteButton {...externalProps} />
                            </React.Fragment>
                        )) ||
                        null
                    }
                </InlineToolbar>
            </div>
        </React.Fragment>
    )
})

class DraftJSClass extends React.PureComponent {
    constructor(props) {
        super(props)
        this.linkPlugin = createLinkPlugin()
        this.inlineToolbarPlugin = createInlineToolbarPlugin()
        this.InlineToolbar = this.inlineToolbarPlugin.InlineToolbar
        this.state = {
            editorState:
                (typeof this.props.value === 'object' &&
                    EditorState.createWithContent(convertFromRaw((this.props.value.source && this.props.value.source) || this.props.value))) ||
                EditorState.createWithContent(ContentState.createFromText(this.props.value || '')) /* || EditorState.createEmpty()*/,
        }
        this.myRef = React.createRef()
    }

    onChange = (editorState, pluginsMethods) => {
        const stateContentState = this.state.editorState.getCurrentContent()

        const currentContent = editorState.getCurrentContent()
        if (stateContentState !== currentContent) {
            this.props.onChange &&
                this.props.onChange({
                    target: { value: { source: convertToRaw(currentContent), html: stateToHTML(currentContent) } },
                })
            // console.log('DraftJS', currentContent, convertToRaw(currentContent), stateToHTML(currentContent, optionsFn(article?.site)))
            // console.log('DraftJS')
            // .entityMap.filter(item => item.type==='LINK')
        }
        this.setState({ editorState })
    }

    focus = () => {
        this.myRef.current.focus()
    }

    handleKeyCommand = (command) => {
        const newState = RichUtils.handleKeyCommand(this.state.editorState, command)
        if (newState) {
            this.onChange(newState)
            return 'handled'
        }
        return 'not-handled'
    }

    componentDidUpdate(prevProps, prevState) {
        // if(prevProps.value.source){ console.log(Object.values(prevProps.value.source.entityMap).length, Object.values(this.props.value.source.entityMap).length) }
        if (prevProps.value.source && prevProps.value.source.entityMap && this.props.value.source && this.props.value.source.entityMap) {
            if (Object.values(prevProps.value.source.entityMap).length !== Object.values(this.props.value.source.entityMap).length) {
                // console.log('NOW')
                // call onChange with this new information
                const stateContentState = this.state.editorState.getCurrentContent()

                this.props.onChange &&
                    this.props.onChange({
                        target: { value: { source: convertToRaw(stateContentState), html: stateToHTML(stateContentState) } },
                    })
            }
            // prevProps.value.source.entityMap.map()
        }
    }

    render() {
        /* const currentContent = this.state.editorState.getCurrentContent()
        const blocks = convertToRaw(currentContent).blocks
        const value = blocks.map((block) => (!block.text.trim() && '\n') || block.text).join('\n') */

        return (
            <React.Fragment>
                <div className={editorStyles.editor} onClick={this.focus}>
                    <Editor
                        editorState={this.state.editorState}
                        onChange={this.onChange}
                        handleKeyCommand={this.handleKeyCommand}
                        plugins={[this.inlineToolbarPlugin, this.linkPlugin]}
                        ref={this.myRef}
                    />
                    <this.InlineToolbar>
                        {(externalProps) => (
                            <React.Fragment>
                                <BoldButton {...externalProps} />
                                <ItalicButton {...externalProps} />
                                <UnderlineButton {...externalProps} />
                                <Separator {...externalProps} />
                                <this.linkPlugin.LinkButton {...externalProps} />
                                <Separator {...externalProps} />
                                <HeadlinesButton {...externalProps} />
                                <UnorderedListButton {...externalProps} />
                                <OrderedListButton {...externalProps} />
                                <BlockquoteButton {...externalProps} />
                            </React.Fragment>
                        )}
                    </this.InlineToolbar>
                </div>
            </React.Fragment>
        )
    }
}

export default Input
